var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92664 3.38927C9.34664 3.21594 8.70664 3.1026 7.99997 3.1026C4.80664 3.1026 2.21997 5.68927 2.21997 8.8826C2.21997 12.0826 4.80664 14.6693 7.99997 14.6693C11.1933 14.6693 13.78 12.0826 13.78 8.88927C13.78 7.7026 13.42 6.59594 12.8066 5.67594M8.82664 1.33594L10.7533 3.54927L8.50664 5.18927",
    stroke: "#D9D9D9",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.d4968614c07bf033aca9624f414a3dd6.svg";
export { ForwardRef as ReactComponent };